<template>
  <div style="background:#fff;">
    <div class="news-main" ref="personDom" :class="{'news-main-mobile' : isMobile == 'mobile'}">
      <div v-for="(news,index) in newsList" :key="news.id">
        <div v-if="index === 0" style="background: #f8f8f8;" :style="isMobile == 'pc' ? 'border-radius:0.5rem': ''">
          <!-- <div class="news-top-list-left" :style="{width: screenWidth>640?'50%':'100%'}">
            <img :src="news.imgUrl" alt="News Image" class="news-image"  referrerPolicy="no-referrer"/>
          </div>
          <div class="news-top-list-right">
            <h2 class="text-max-5 text-max">{{ news.title }}</h2>
            <p class="news-title" style="color: #8D8E99;">{{ news.digest }}</p>
            <p class="date" v-if="screenWidth <= 640">{{ news.createDate?news.createDate.split(' ')[0]:'' }}</p>
            <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width:100%;position: absolute;bottom: 0;left: 0;">
              <span class="date" v-if="screenWidth > 640">{{ news.createDate?news.createDate.split(' ')[0]:'' }}</span>
              <a href="#" @click="toJump(news.title,news.id)" class="more">
                <div class="btn-more">
                  {{$t('ViewDetails')}} <i class="el-icon-right"></i>
                </div>
              </a>
            </div>

          </div> -->
          <el-row :gutter="20" v-if="isMobile == 'pc'">
            <el-col :span="screenWidth>640?13:24">
              <img style="width: 100%;border-radius: 1rem;height:14rem;object-fit: cover;" :src="news.imgUrl" alt="" @click="toJump(news.title,news.id)">
            </el-col>
            <el-col :span="screenWidth>640?11:24">
              <div>
                <div style="padding:0 4% 0 0">
                  <h2 class="news-title" @click="toJump(news.title,news.id)" style="cursor: pointer;">{{ news.title }}</h2>
                  <div :class="screenWidth>900?'text-max-2':'news-title'" style="color: #8D8E99;line-height: 2;">{{ news.digest }}</div>
                  <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width:100%;margin-top:1rem">
                    <span class="date">{{ news.createDate?news.createDate.split(' ')[0]:'' }}</span>
                    <a href="#" @click="toJump(news.title,news.id)" class="more">
                      <div class="btn-more">
                        {{$t('ViewDetails')}} <i class="el-icon-right"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 移动端 -->
          <div v-if="isMobile == 'mobile'">
            <div>
              <img style="width: 100%;object-fit: cover;border-top-left-radius: 8px;border-top-right-radius: 8px;height: 18rem;" :src="news.imgUrl" alt="" @click="toJump(news.title,news.id)">
            </div>
            <div>
              <div>
                <div class="new-box">
                  <div class="news-title-mobile" @click="toJump(news.title,news.id)">{{ news.title }}</div>
                  <div class="news-title-mobile-txt" style="color: #8D8E99;">{{ news.digest }}</div>
                  <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width:100%;margin-top:10px;padding-bottom:14px;">
                    <span class="date">{{ news.createDate?news.createDate.split(' ')[0]:'' }}</span>
                    <a href="#" @click="toJump(news.title,news.id)" class="more">
                      <div class="btn-more-mobile">
                        {{$t('ViewDetails')}} <i class="el-icon-right"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="news-bottom-list" v-if="isMobile == 'pc'">
            <div >
              <div class="news-bottom-list-left">
                <img :src="news.imgUrl" alt="News Image" class="news-image" referrerPolicy="no-referrer" @click="toJump(news.title,news.id)" />
              </div>
              <div class="news-bottom-list-right">
                <h3 class="news-title" @click="toJump(news.title,news.id)" style="cursor: pointer;">{{ news.title }}</h3>
                <p class="news-title" style="color: #8D8E99;line-height: 2;">{{ news.digest }}</p>
                <div style="display: flex;flex-direction: row;justify-content: space-between;width:100%">
                  <span class="date">{{ news.createDate?news.createDate.split(' ')[0]:'' }}</span>
                  <a href="#" @click="toJump(news.title,news.id)" class="more">{{$t('ViewDetails')}} <i class="el-icon-right"></i></a>
                </div>
              </div>
            </div>
          </div>
          <!-- 移动端 -->
          <div class="news-bottom-list-mobile" v-if="isMobile == 'mobile'">
            <div class="news-bottom-list-mobile-box" v-if="isMobile == 'mobile'">
              <div class="news-bottom-list-left-mobile">
                <img :src="news.imgUrl" alt="News Image" class="news-image" referrerPolicy="no-referrer" @click="toJump(news.title,news.id)"/>
              </div>
              <div class="news-bottom-list-right-mobile">
                <div class="news-title-mobile" @click="toJump(news.title,news.id)">{{ news.title }}</div>
                <div class="news-title" style="color: #8D8E99;margin-top:10px;">{{ news.digest }}</div>
                <div style="display: flex;flex-direction: row;justify-content: space-between;width:100%;margin-top:10px;">
                  <span class="date">{{ news.createDate?news.createDate.split(' ')[0]:'' }}</span>
                  <a href="#" @click="toJump(news.title,news.id)" class="more">{{$t('ViewDetails')}} <i class="el-icon-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div style="width: 100%;text-align: center;font-size: 1.5rem;margin-top:2rem" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </div>
  
</template>

<script>
import { pageArticleByModuleId } from "@/api/index";
import { mapState } from 'vuex'
import mixin from '@/mixins/scroll'

export default {
  mixins: [mixin],
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      newsList: [],
      title: "",
      page: 1,
      loading: false
    };
  },
  mounted() {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    meta.setAttribute('content', 'never');
    document.head.appendChild(meta);

    this.title = this.$route.query.search;
    this.pageArticleByModuleIds(1)
  },
  methods: {
    toJump(title, id) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          title: title,
          id: id,
		  fundId:1
        },
      });
    },
    scrolling() {
      // scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop
      // windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight
      // scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight
      let bottom = scrollHeight - scrollTop - windowHeight;
      if (!this.loading && bottom < 250 && this.page < this.totalPage) {
        this.page++
        this.loading = true
        setTimeout(() => {
          this.pageArticleByModuleIds(this.page)
        }, 10);

      }
    },

    async pageArticleByModuleIds(p) {
      let res = await pageArticleByModuleId({
        "moduleId": 1,
        "page": p,
        "size": 10,
        "title": this.title
      })
      if (res.data && res.data != null) {
        if (p == 1) {
          this.newsList = res.data.records
        } else {
          this.newsList = [...this.newsList, ...res.data.records]
        }
        this.loading = false
        this.totalPage = res.data.pages
      }

    },
  },
};
</script>

<style lang="less" scoped>
.news-main-mobile {
  box-sizing: border-box;
  background: #fff!important;
  width: 100%!important;
  padding: 20px 18px 20px!important;
}
.new-box{
  background: #f8f8f8;
  padding: 0 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .news-title-mobile{
    font-size: 18px;
    color: #000;
    font-weight: 800;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-top: 15px;
  }
  .news-title-mobile-txt{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgb(141, 142, 153);
    padding-top: 8px;
  }
  .btn-more-mobile{
    width: 8rem;
    height: 2rem;
    line-height: 2rem;
    text-align: right;
    cursor: pointer;
  }
}
.news-bottom-list-mobile {
  box-sizing: border-box;
  border-radius: 0.5rem;
  width: 100%;
  height: 8rem;
  margin-top: 2rem;
  background: #f8f8f8;
  .news-bottom-list-mobile-box {
    display: flex;
    align-items: center;
    .news-bottom-list-left-mobile{
      display: flex;
      flex: 1;
      height: 8rem;
      overflow: hidden;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      img{
        width: 100%;
        height: 8rem;
        object-fit: cover;
      }
    }
  }
  .news-bottom-list-right-mobile{
    margin-left: 2%;
    // width: 70%;
    width: 190px;
    padding-right: 8px;
    .news-title-mobile{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 800;
    }
  }
}




.news-main {
  box-sizing: border-box;
  // background: #f8f9fc;
  width: 80%;
  padding: 3rem 0;
  margin: 0 auto;
}

.news-top-list {
  box-sizing: border-box;
  border-radius: 0.5rem;
  width: 100%;
  height: 25rem;
  padding: 1rem 2rem;
  margin-top: 2rem;
  background: white;
  .news-top-list-left {
    float: left;
    width: 60%;
    border-radius: 0.5rem;
    height: 23rem;
    overflow: hidden;
    .news-image {
      width: 100%;
      height: 23rem;
    }
  }
  .news-top-list-right {
    float: left;
    margin-left: 2%;
    width: 38%;
    height: 23rem;
    position: relative;
  }
}
.news-bottom-list {
  box-sizing: border-box;
  border-radius: 0.5rem;
  width: 100%;
  height: 10rem;
  padding: 0 1rem 0 0;
  margin-top: 2rem;
  background: #f8f8f8;
  .news-bottom-list-left {
    float: left;
    width: 28%;
    border-radius: 0.5rem;
    height: 10rem;
    overflow: hidden;
    .news-image {
      width: 100%;
      height: 10rem;
      object-fit: cover;
    }
  }
  .news-bottom-list-right {
    float: left;
    margin-left: 2%;
    width: 70%;
  }
}

.more {
  text-decoration: none !important;
  color: #221f20 !important;
}
</style>